import GalleryType from "@/domain/galleryTree/constants/galleryType";

export const isPrivateGallery = gallery => !!gallery && gallery.type === GalleryType.PRIVATE.value

// Con can_see_media = false le gallery private non devono comparire nel tree.
// Se la gallery richiesta e' essa stessa privata (es. URL diretto) la svuotiamo,
// cosi' Checkin.vue ricade su UserCtas / CtaCantSeePhotosInStay.
export const hidePrivateGalleries = (gallery, canSeeMedia) => {
    if (!gallery || canSeeMedia !== false) return gallery
    if (isPrivateGallery(gallery)) {
        return {...gallery, num_media: 0, sub_gallery: [], tabs: []}
    }
    const subs = Array.isArray(gallery.sub_gallery) ? gallery.sub_gallery : []
    const visibleSubs = subs.filter(g => !isPrivateGallery(g))
    // num_media della root conta anche le gallery private appena tolte: se non resta
    // niente di visibile lo azzeriamo, altrimenti Checkin.vue mostra un tree vuoto.
    const hasOwnMedia = (gallery.tabs || []).some(tab => tab.count > 0)
    const hasVisibleMedia = hasOwnMedia || visibleSubs.some(g => g.num_media > 0)
    return {...gallery, sub_gallery: visibleSubs, num_media: hasVisibleMedia ? gallery.num_media : 0}
}
